import "../../styles/OnboardingScreen1.css";
import screen1Img from "../../assets/onboarding/screen1.png";

export default function OnboardingScreen1() {
  return (
    <div className="ob1">
      <div className="ob1Text">
        <h1>
          Це повноцінний <br />
          онлайн-магазин 
          пива
        </h1>

        <p>
          Тут можна переглядати каталог,
          
          дивитися популярні позиції
          
          або просто написати,
          
          що ти любиш.
        </p>

        <p className="highlight">
          Чат — <span>найзручніший спосіб</span>
          <br />
          швидко знайти своє пиво.
        </p>
      </div>

      {/* 🔥 ЗАМІСТЬ CSS — КАРТИНКА */}
      <div className="ob1ImageWrap">
        <img src={screen1Img} alt="Onboarding" />
      </div>
    </div>
  );
}